import React from 'react'
import { useParallaxInView } from '../../lib/hooks'
import { Section } from '../section/section.component'
import { ContactForm } from '../contact-form/contact.component'
import {
  base,
  containers,
  imageStyles,
  useScroll,
  useSpring,
  useInView,
  animations,
  motion,
} from '../../styles/base/_allBase.styles'
const { H3, StyleP, CenterDiv } = base
const { TwoColumnGrid, GridItem } = containers
const { ImgCover } = imageStyles
import { Container } from './contact-input.styles'
import { analyticsModuleAttributes } from '../../lib/analytics-content.mjs'

function ContactInputSection({ image }) {
  const { y, ref, isInView } = useParallaxInView(-50)
  return (
    <Section
      cursorsize={'small'}
      size={'auto'}
      {...analyticsModuleAttributes({ _key: 'contact-form' }, 'contact_form')}
    >
      <TwoColumnGrid>
        <GridItem>
          <ContactForm />
        </GridItem>

        <GridItem>
          <div
            style={{
              position: 'relative',
              margin: '0rem 6rem',
              padding: '4rem 4rem',
              height: '100%',
            }}
          >
            <ImgCover src={image} layout="fill" />
          </div>
        </GridItem>
      </TwoColumnGrid>
    </Section>
  )
}

export { ContactInputSection }
